export default __webpack_public_path__ + "static/media/laundry1-beforeA-1440w.f97e5952.webp";